import React, { Component } from 'react';
import * as Styles from './Styles';
import FilePicker from './FilePicker';

type Props = {};

type State = {};

class Files extends Component<Props, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper>
				<Styles.HeadingFont>
					Wybierz odpowiednią zakładkę, aby zobaczyć interesujące Cię
					dokumenty
				</Styles.HeadingFont>
				<Styles.HeadingLowerFont>
					możesz też pobrać wszystkie dokumenty używając przycisku
					znajdującego się pod tabelą
				</Styles.HeadingLowerFont>
				<Styles.ContentContainer>
					<Styles.Divider />
					<FilePicker />
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

export default Files;
